// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoginV2YXSN_wrapper__5T3ON"};